'use client';

import Link from 'next/link';
import FaIcon, { faTruck } from '../../../../components/icon/FaIcon/FaIcon';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { DELIVERY_STATUS } from '../../constants';
import type { DeliveryManagement } from '../../types';
import { estimatedShippingDateText } from '../../utils';
import styles from './DeliveryEventList.module.scss';

// 配送ステータスの日本語変換
const getStatusLabel = (status: string): string => {
  const statusEntry = Object.values(DELIVERY_STATUS).find((entry) => entry.value === status);
  return statusEntry?.text || status;
};

export type DeliveryEventListProps = {
  eventList: Array<DeliveryManagement>;
};

function DeliveryEventList({ eventList }: DeliveryEventListProps) {
  return (
    <ul className={styles.deliveryEventList}>
      {eventList.length === 0 && (
        <li className={styles.itemContainer}>
          <div className={styles.itemDetail}>
            <div className={styles.itemTitle}>配送予定の景品はありません</div>
          </div>
        </li>
      )}
      {eventList.map((item: DeliveryManagement) => (
        <li key={item.id} className={styles.itemContainer}>
          {/* @ts-ignore */}
          <Link href={`/delivery/${item.id}`} className={`${styles.itemLink} ${utilsStyles.mtXSmall}`} prefetch={false}>
            <div className={styles.itemImage}>
              <ImageView alt={item.event.name} src={item.event.imageUrl} isFreeSize={true} />
            </div>
            <div className={styles.itemDetail}>
              <div>
                <h2 className={`${styles.itemTitle} ${utilsStyles.textBold}`}>{item.event.name}</h2>
                <div className={styles.estimatedShippingDate}>
                  <FaIcon icon={faTruck} />
                  &nbsp;
                  {estimatedShippingDateText({
                    estimatedShippingDate: item.delivery.estimatedShippingDate || undefined,
                  })}
                </div>
              </div>
              <div className={styles.itemDetailWrapper}>
                <div className={`${utilsStyles.textSmall} ${utilsStyles.mtXSmall}`}>
                  配送ステータス：{getStatusLabel(item.delivery.status)}
                </div>
                <div className={`${utilsStyles.textSmall} ${utilsStyles.mtXSmall}`}>
                  <p className={utilsStyles.textSmall}>保有数：{item.delivery.acquiredCount}</p>
                </div>
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default DeliveryEventList;
